var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useRecoilValue } from 'recoil';
import { useNavigate, useLocation } from 'react-router-dom';
import { appProgressState, useProgress } from '../Domain/State/AppState';
export function Progressbar() {
    var location = useLocation();
    var navigate = useNavigate();
    var getCurrentRoute = useProgress().getCurrentRoute;
    var _a = useRecoilValue(appProgressState), steps = _a.steps, currentStep = _a.currentStep;
    useEffect(function () {
        if (location.pathname !== getCurrentRoute()) {
            navigate(getCurrentRoute());
        }
    }, [currentStep]);
    useEffect(function () {
        if (!steps.some(function (step) {
            if (!step.completed) {
                navigate(step.route);
                return true;
            }
            return false;
        })) {
            navigate(getCurrentRoute());
        }
    }, []);
    return (_jsx("div", __assign({ className: "progress-bar" }, { children: steps.map(function (step, index) {
            var iteration = index + 1;
            return (_jsxs("div", __assign({ className: "progress-bar__step".concat(currentStep >= index ? ' active' : '').concat(currentStep === index ? ' current' : '') }, { children: [_jsxs("div", __assign({ className: "step" }, { children: [_jsx("div", { className: "segment ".concat(index === 0 ? 'hidden' : '') }), _jsx("div", __assign({ className: "step__number" }, { children: iteration })), _jsx("div", { className: "segment ".concat(iteration === steps.length ? 'hidden' : '') })] })), _jsx("div", __assign({ className: "step__name" }, { children: step.label }))] }), index));
        }) })));
}
